export default __webpack_public_path__ + "static/media/temple.f24af5a1.svg";